import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ReportagemR8: React.FC = () => (
  <div style={{
    minHeight: '100vh',
    background: '#0a0a0a',
    color: '#222',
    fontFamily: "'Inter', Arial, Helvetica, sans-serif",
    display: 'flex',
    flexDirection: 'column'
  }}>
    <Header />
    <main style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }}>
      <div style={{
        maxWidth: 900,
        width: '100%',
        margin: '40px auto',
        background: '#fff',
        padding: 32,
        borderRadius: 8,
        boxSizing: 'border-box',
        boxShadow: '0 2px 12px rgba(0,0,0,0.07)'
      }}>
        <h1 style={{ color: '#0a3d62', marginTop: 0 }}>Prestadora de Serviços Investigada por Falsificação e Lavagem de Dinheiro</h1>
        <div style={{ color: '#888', fontSize: '0.95em', marginBottom: 24 }}>
          Edição nº 87 | Outubro 2025
        </div>
        <h2 style={{ color: '#222', fontWeight: 600, marginBottom: 12 }}>
          Depoimento vazado revela que clientes sabiam do descarte irregular e se beneficiavam do menor preço.
        </h2>
        <img
          src="/images/accor/reportagemNacional.png"
          alt="Aterro do Aurá"
          style={{
            width: '100%',
            maxWidth: 700,
            borderRadius: 8,
            margin: '20px 0'
          }}
        />
        <p>
          O Ministério Público do Pará está investigando uma prestadora de serviços por suspeita de falsificação de laudos de descarte e envolvimento em esquema de lavagem de dinheiro. A empresa, que atua com redes hoteleiras como Accor, Radisson e Bristol, é acusada de práticas ilegais que podem expor seus clientes a riscos legais e reputacionais.
          Segundo informações divulgadas pelas autoridades, a investigação aponta que a empresa Lev Descartes teria emitido laudos falsos sobre o descarte de resíduos, mascarando práticas irregulares que violam normas ambientais. Além disso, há indícios de que a empresa esteja envolvida em um esquema de lavagem de dinheiro, utilizando contratos com a municipalidade e empresas privadas para encobrir movimentações financeiras suspeitas.
        </p>
        <p>
          O caso ganhou novos contornos após o vazamento do depoimento do proprietário da Lev Descartes, que alegou que os clientes estavam cientes do descarte irregular e não reclamavam, pois a empresa oferecia o menor preço do mercado. Essa declaração levanta preocupações sobre a responsabilidade compartilhada entre prestadora e contratantes.
        </p>

        <br></br>
        <blockquote style={{
          borderLeft: '4px solid #0a3d62',
          margin: '16px 0 0 0',
          paddingLeft: 16,
          color: '#444',
          fontStyle: 'italic'
        }}>
          Olha, eu sempre descartei no Aurá porque a própria prefeitura disse que ia regularizar tudo. Nunca tive problema com cliente, ninguém nunca reclamou. Pelo contrário, eu oferecia o melhor preço da região. A outra empresa que concorria comigo já tinha sido investigada, então todo mundo preferia fechar comigo.
          Isso é prática comum por aqui, todo mundo faz. Não tem nada demais. O pessoal gosta de fazer alarde, mas quem tá no ramo sabe como funciona. Se fosse tão errado assim, já teriam fechado tudo há muito tempo
          "<br />
          <span style={{ fontWeight: 500 }}>— Depoimento vazado</span>
        </blockquote>




        <br></br>

        <div style={{
          background: '#eaf6fb',
          borderRadius: 6,
          padding: 18,
          margin: '32px 0',
          color: '#0a3d62',
          fontWeight: 500,
          fontSize: '1.1em'
        }}>
          <br />
          O Ministério Público segue com as investigações e não descarta novas ações contra empresas que tenham se beneficiado dos serviços da Lev Descartes.<br />
        </div>
      </div>
    </main>
    <Footer />
  </div>
);

export default ReportagemR8;